import { request } from './request'
// 获取任务列表
export interface GetTaskListData {
  limit: number
  page: number
  name?: string
  start_time?: string
  end_time?: string
  status?: number
}
export const getTaskList = (params: GetTaskListData) =>
  request('/portal/verify/phish/campaign/task', {
    params,
  })

// 修改任务结束时间
export interface EndTaskData {
  id?: string
}
export const endTask = (data: EndTaskData) =>
  request('/portal/verify/phish/campaign/task/time/end', {
    method: 'PATCH',
    data,
  })

// 删除任务
export interface DeleteTaskData {
  id: string[]
}
export const deleteTask = (data: DeleteTaskData) =>
  request('/portal/verify/phish/campaign/task', {
    method: 'delete',
    data,
  })

// 新建任务
export interface CreateTaskData {
  campaign_name: string
  create_time?: string
  start_time: string
  end_time: string
  page_id: string
  attach_id: string
  url?: string
  email_type: string
  email_content: string
  email_subject: string
  email_sender: string
  email_name: string
  email_cover: string
  email_id: string
  email_link: string
  targets: object[]
  dept_str: string
  group_id_list: string
  tag_str: string
  notice_mail: string
  zip_pwd: string
  set_time: string
  set_day: number
  set_type: number
  email_from: number
  attach_name: string
  interval: number
  smtp_id: string
  security_id: string
  is_commit_data: number
}

export const createTask = (data: CreateTaskData) =>
  request('/portal/verify/phish/campaign/task', {
    method: 'post',
    data,
  })
// 附件模板

export interface GetAttachments {
  limit: number
  page: number
  name?: string
  template_id: string
}
export const getAttachments = (data: GetAttachments) =>
  request('/portal/verify/phish/campaign/attachment/list', {
    params: {
      ...data,
    },
  })
// 钓鱼模板
export interface GetPhishingPages {
  limit: number
  page: number
  template_id: string
}
export const getPhishingPages = (data: GetPhishingPages) =>
  request('/portal/verify/phish/campaign/page/list', {
    params: {
      ...data,
    },
  })
// 邮件模板/邮件搜索
export interface GetEmail {
  limit: number
  page: number
  email_type?: number
  name?: string
}
export const getEmail = (data: GetEmail) =>
  request('/portal/verify/phish/campaign/template/list', {
    params: {
      ...data,
    },
  })
// 获取目标列表
export interface GetTargetList {
  tag_ids?: string[]
  keyword?: string
}
export const getTargetList = (data: GetTargetList) =>
  request('/portal/verify/phish/campaign/target/list', {
    method: 'POST',
    data,
    timeout: 1000 * 60,
  })
// 生成报表
export interface GetTaskReport {
  campaign_id: string
  campaign_type: number
  task_name: string
  report_name: string
}
export const getTaskReport = (data: GetTaskReport) =>
  request('/portal/verify/phish/campaign/task/report', {
    method: 'POST',
    data,
  })

// 获取配置文件中的白名单ip
export const getIp = () => request('/portal/verify/phish/campaign/white/ip')
// 获取可添加邮箱域名
export const getTargetDomain = () => request('/portal/verify/phish/contacts/target/domain')

export interface GetSecurityTemplate {
  limit: number
  page: number
  keyword: string
}
export const getSecyTemplate = (data: GetSecurityTemplate) =>
  request('/portal/verify/phish/resource/template/security', {
    params: {
      ...data,
    },
  })

export interface GetCampaignSmtp {
  email_type: string
}
export const getCampaignSmtp = (data: GetCampaignSmtp) =>
  request('/portal/verify/phish/campaign/smtp', {
    params: {
      ...data,
    },
  })

export interface GetAiEmailTemplate {
  subject: string
  emailType: string
}
// 获取AI邮件模板列表
export const getAiEmailTemplate = (data: GetAiEmailTemplate) =>
  request('/portal/v1/phish/ai_email_template', {
    params: {
      ...data,
    },
    timeout: 1000 * 120,
  })

export interface CreateAiEmailTemplate {
  /**
   * 邮件正文
   */
  content?: string
  /**
   * 更改为钓鱼页的链接
   */
  link?: string
  /**
   * 模板名称
   */
  name?: string
  /**
   * 发件人
   */
  sender?: string
  /**
   * 邮件主题
   */
  subject?: string
  /**
   * 图标
   */
  cover?: string
  /**
   * 邮件类型
   */
  emailType?: string
  [property: string]: any
}
// 创建AI邮件模板
export const createAiEmailTemplate = (data: CreateAiEmailTemplate) =>
  request('/portal/v1/phish/ai_email_template', {
    method: 'POST',
    data,
  })

export interface GetAiPhishingPageTemplate {
  /**
   * 提交信息
   */
  message1?: string
  /**
   * 提交信息
   */
  message2?: string
  /**
   * 主题
   */
  subject?: string
  [property: string]: any
}
// 获取AI钓鱼页模板列表
export const getAiPhishingPageTemplate = (data: GetAiPhishingPageTemplate) =>
  request('/portal/v1/phish/ai_phish_page_template', {
    params: {
      ...data,
    },
    timeout: 1000 * 120,
  })

export interface CreateAiPhishingPageTemplate {
  /**
   * 正文
   */
  content?: string
  /**
   * 模板名称
   */
  name?: string
  [property: string]: any
}
// 创建AI钓鱼页模板
export const createAiPhishingPageTemplate = (data: CreateAiPhishingPageTemplate) =>
  request('/portal/v1/phish/ai_phish_page_template', {
    method: 'POST',
    data,
  })

export const checkAvailableStatus = () => request('/portal/v1/phish/ai/available_status')
